import React from 'react';
import { Routes, Route } from 'react-router-dom'; // ← Remove BrowserRouter import
import Header from './components/Header.jsx';

import './App.css';
import WorkPage from './pages/WorkPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import ServicePage from './pages/ServicePage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import HomePage from './pages/Home.jsx';

function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/worktime" element={<WorkPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </div>
  );
}

export default App;